import { Form } from 'factorial-form'

class CompanyRepresentative extends Form {
  constructor(values: object) {
    super(values, {
      representative_identifier: 'string',
      representative_name: 'string',
      representative_first_surname: 'string',
      representative_second_surname: 'string',
      representative_job_title: 'string',
    })
  }
}

export default CompanyRepresentative
